import { name } from './slice';
import type { ICountry } from './types';

export const getCountriesList = (state): ICountry[] => state[name].list;
